export enum eQuizEditCheckedOptions {
  SHUFFLE_ANSWERS = 1,
  TIME_LIMIT = 2,
  MULTIPLE_ATTEMPTS = 3,
  ACCESS_CODE = 4,
}
